export const getCurrentPathData = (pathId: string, userId: string) => {
  const pathKey = `path_${pathId}_${userId}`;
  const stored = localStorage.getItem(pathKey);
  return stored ? JSON.parse(stored) : null;
};
